import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import { LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import AmortizationCalculator from "./AmortizationCalculator.esm.js";
import { FieldConfig } from "./AmortizationCalculator.utils.esm.js";
const AmortizationCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      amount,
      term,
      rate,
      startMonth,
      startYear
    } = attrs;
    const defaultValues = {
      amount,
      term,
      rate,
      startMonth,
      startYear
    };
    return /* @__PURE__ */ jsx(AmortizationCalculator, { ...{
      defaultValues
    }, ...isEditor() && {
      editorMode: true,
      key: JSON.stringify(defaultValues)
    } });
  },
  metadata: {
    version: "1.0",
    name: "constellation/amortization-calculator",
    title: "Amortization Calculator",
    description: "Show how a mortgage is paid down over time, with a payment schedule.",
    icon: "businessperson",
    keywords: ["mortgages", "calculators", "amortization"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Calculators",
    attributes: {
      amount: {
        type: "number",
        default: 2e5,
        label: "Loan amount",
        control: "number"
      },
      term: {
        type: "string",
        default: LOAN_PROGRAMS.fixed30Year,
        label: "Loan program",
        control: "select",
        choices: FieldConfig.term.options
      },
      rate: {
        type: "number",
        label: "Interest rate",
        default: 4.176,
        control: "number"
      },
      startMonth: {
        type: "string",
        default: "Aug",
        label: "Loan start date",
        control: "select",
        choices: [{
          label: "Jan",
          value: "Jan"
        }, {
          label: "Feb",
          value: "Feb"
        }, {
          label: "Mar",
          value: "Mar"
        }, {
          label: "Apr",
          value: "Apr"
        }, {
          label: "May",
          value: "May"
        }, {
          label: "Jun",
          value: "Jun"
        }, {
          label: "Jul",
          value: "Jul"
        }, {
          label: "Aug",
          value: "Aug"
        }, {
          label: "Sep",
          value: "Sep"
        }, {
          label: "Oct",
          value: "Oct"
        }, {
          label: "Nov",
          value: "Nov"
        }, {
          label: "Dec",
          value: "Dec"
        }]
      },
      startYear: {
        type: "number",
        default: 2024,
        label: "Loan start date",
        control: "select",
        choices: [{
          label: "Loan start date low",
          value: 1900
        }, {
          label: "Loan start date high",
          value: 2100
        }]
      }
    }
  }
};
export {
  AmortizationCalculatorBlock as default
};
